import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { DashComponent } from './modules/globals/dash/dash.component';
import { PagesComponent } from './modules/globals/dash/components/pages/pages/pages.component';
import { SuperadminComponent } from './modules/globals/superadmin/superadmin.component';

@NgModule({
  declarations: [
    AppComponent,
    DashComponent,
    SuperadminComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule,
    SharedModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
